module.exports = __webpack_public_path__ + "img/logo4.04e4a3d2.png";